
                import "css-modules://src_components_footer"
                export default {"Main":"_5b8182","Columns":"_e13d64","Eyebrow":"_7bcf59","Title":"_acbc0a","Text":"_a5ef3b","Navigation":"_9c87df"}
            